import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { useAddNotification } from 'hooks/useAddNotification'
import { del } from 'utils/http'

export const useCustomerRevealApiKeyDelete = () => {
  const customerId = useCustomerId()
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()

  const deleteApiKey = () => del(`/management/reveal_api/customers/${customerId}`)

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: deleteApiKey,
    onSuccess: () => {
      queryClient.setQueryData(['customer', customerId, 'reveal_api_quota'], {})
      queryClient.invalidateQueries({ queryKey: ['customer', String(customerId)], refetchType: 'none' })
      addNotification('Reveal API key has been removed')
    },
    onError: () => {
      addNotification('Error while removing Reveal API key', 'error')
    },
  })

  return {
    deleteRevealApiKey: mutateAsync,
    ...rest,
  }
}
